export const FETCH_NAVIGATION_PENDING = "FETCH_NAVIGATION_PENDING";
export const FETCH_NAVIGATION_REJECTED = "FETCH_NAVIGATION_REJECTED";
export const FETCH_NAVIGATION_FULFILLED = "FETCH_NAVIGATION_FULFILLED";
export const SET_SELECTED_CATEGORY = "SET_SELECTED_CATEGORY";



// WEBPACK FOOTER //
// ./src/constants/navigation.js